import exportComponentsToRails from "../src/shared/utilities/exportComponentsToRails";

exportComponentsToRails("claimDealHDP", {
  claimForm: import("../src/features/claim-deals/components/App"),
  claimMessage: import(
    "../src/features/claim-deals/components/ClaimedDealHDPMessage"
  )
});
